import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyle {
  wrapper: FelaCSS;
  icon: FelaCSS;
  value: FelaCSS;
  label: FelaCSS;
  item: FelaCSSWithCustomSelectors;
}

export default (): IStyle => ({
  wrapper: {
    marginTop: 4,
    order: 5,
    flexDirection: 'row',
    maxWidthTabletSm: {
      marginBottom: 4,
    },
  },
  item: {
    position: 'relative',
    flexBasis: `50%`,
    alignItems: 'center',
    '&:first-of-type::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      width: 1,
      height: 44,
      top: '50%',
      transform: 'translate(0, -50%)',
      borderRight: `1px solid ${colors.space15}`,
    },
  },
  value: {
    fontDefaultSemiBold: 24,
    marginTop: 4,
    maxWidthMobile: {
      marginTop: 2,
      fontDefaultSemiBold: 18,
    },
  },
  icon: {
    fontDefault: 32,
    maxWidthMobile: {
      fontDefault: 26,
    },
  },
  label: {
    fontDefault: 14,
    color: colors.space60,
  },
});
